module.exports = __webpack_public_path__ + "static/media/post-2.fd0b5d5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post-2.jpg
// module id = 1182
// module chunks = 33